import type { CanvasAttribution as CanvasAttributionData } from '@ispot/shared'

interface CanvasAttributionProps {
  attribution: CanvasAttributionData
  className?: string
}

export function CanvasAttribution({ attribution, className }: CanvasAttributionProps) {
  const { framework, author, source, year, url, note } = attribution

  const citationCore = (
    <>
      {author}
      {source && (
        <>
          , <em className="not-italic italic">{source}</em>
        </>
      )}
      {year !== undefined && ` (${year})`}
    </>
  )

  return (
    <footer
      aria-label="Framework reference"
      className={[
        'flex flex-wrap items-baseline gap-x-2.5 gap-y-1',
        'px-8 pt-5 pb-7 text-[11.5px] leading-relaxed text-[var(--color-fg-faint,#a3a39d)]',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span
        className="font-mono uppercase tracking-[0.1em] text-[10px] text-[var(--color-fg-muted,#767670)] bg-[var(--color-warm-100,#f8f6f0)] border border-[var(--color-border-subtle,#efedea)] rounded-full px-2 py-0.5"
      >
        Framework
      </span>
      <span>
        <strong className="text-[var(--color-fg-muted,#767670)] font-semibold">{framework}</strong>
        {' · '}
        {url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[var(--color-fg-muted,#767670)] no-underline border-b border-dotted border-[var(--color-fg-faint,#a3a39d)] hover:text-[var(--color-fg-secondary,#4b5e69)] hover:border-[var(--color-fg-secondary,#4b5e69)] transition-colors"
          >
            {citationCore}
          </a>
        ) : (
          citationCore
        )}
        {note && <span> · {note}</span>}
      </span>
    </footer>
  )
}
